import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRight = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M255.593 867.405l331.094-331.090-331.094-331.093c-33.28-33.28-33.28-87.040 0-120.32s87.040-33.28 120.32 0l391.68 391.68c33.28 33.28 33.28 87.040 0 120.32l-391.68 391.677c-33.28 33.28-87.040 33.28-120.32 0-32.427-33.28-33.28-87.893 0-121.173z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgChevronRight);
export default ForwardRef;
